import BasePage from '../basePage'

import { Filter } from './Filter'
import { NetPromote } from './NetPromote'
import { Stars } from './Stars'
import { Comments } from './Comments'
import { CancelamentoAssinatura } from './CancelamentoAssinatura'

import { Container } from './styles'

import { AssessmentsProvider } from '../../hooks/AssessmentsContext'
import { CommentsProvider } from '../../hooks/CommentsContext'
import { Tabs } from '../../components/ui/Tabs'
import { motion } from "framer-motion";
import { useMenu } from '../../store/global/useMenu'
import { ChartNoAxesCombined } from 'lucide-react'

export function Avaliacoes() {

  const menuSize = useMenu(st => st.data.size)

  return (
    <BasePage pageTitle={<><ChartNoAxesCombined className='w-7 h-7' />Avaliações</>}>
      <AssessmentsProvider>
        <motion.div
          initial={{ width: `calc(100vw - 2rem - ${menuSize})` }}
          animate={{ width: `calc(100vw - 2rem - ${menuSize})` }}
          transition={{ duration: 0.3 }}
          className='flex flex-col pt-1.5 pr-4'>
          <Tabs.Root name="avaliacoes" tabs={["NPS", "Cancelamento Assinatura"]}>
            <Tabs.Content name="avaliacoes" tabName="NPS">
              <Container container spacing={3}>
                <Filter />
                <NetPromote />
                <Stars />
                <CommentsProvider>
                  <Comments />
                </CommentsProvider>
              </Container>
            </Tabs.Content>

            <Tabs.Content name="avaliacoes" tabName="Cancelamento Assinatura">
              <CancelamentoAssinatura />
            </Tabs.Content>
          </Tabs.Root>
        </motion.div>
      </AssessmentsProvider>
    </BasePage >
  )
}
